import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListItemDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 12C23.1748 13.5305 23.998 14.554 24.8379 16.5943C24.903 16.7526 25.1254 16.7644 25.2066 16.6137C27.9645 11.4894 30.1186 8.86343 35 5",
			stroke: "#6C6DCE",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2568 4.00684C30.0705 4.04801 30.8327 4.28396 31.4981 4.66869C31.7516 4.81528 31.6875 5.20576 31.4739 5.40606C31.3269 5.54388 31.1038 5.59116 30.9273 5.49395C30.3557 5.17908 29.6987 5 29 5H19C16.7909 5 15 6.79086 15 9V18C15 20.2091 16.7909 22 19 22H29C31.2091 22 33 20.2091 33 18V9C33 8.94811 33.0304 8.90189 33.0782 8.88186C33.1531 8.85051 33.2249 8.8133 33.293 8.77079C33.5313 8.62205 34 8.7191 34 9V18L33.9932 18.2568C33.8595 20.8989 31.6753 23 29 23H19C16.3247 23 14.1405 20.8989 14.0068 18.2568L14 18V9C14 6.32472 16.1011 4.14053 18.7432 4.00684L19 4H29L29.2568 4.00684Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 34C23.1748 35.5305 23.998 36.554 24.8379 38.5943C24.903 38.7526 25.1254 38.7644 25.2066 38.6137C27.9645 33.4894 30.1186 30.8634 35 27",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2568 26.0068C30.0705 26.048 30.8327 26.284 31.4981 26.6687C31.7516 26.8153 31.6875 27.2058 31.4739 27.4061C31.3269 27.5439 31.1038 27.5912 30.9273 27.4939C30.3557 27.1791 29.6987 27 29 27H19C16.7909 27 15 28.7909 15 31V40C15 42.2091 16.7909 44 19 44H29C31.2091 44 33 42.2091 33 40V31C33 30.9481 33.0304 30.9019 33.0782 30.8819C33.1531 30.8505 33.2249 30.8133 33.293 30.7708C33.5313 30.622 34 30.7191 34 31V40L33.9932 40.2568C33.8595 42.8989 31.6753 45 29 45H19C16.3247 45 14.1405 42.8989 14.0068 40.2568L14 40V31C14 28.3247 16.1011 26.1405 18.7432 26.0068L19 26H29L29.2568 26.0068Z",
			fill: "white",
			fillOpacity: .24
		})
	]
});
export default SvgListItemDark;
